<template>
  <div>
    <FITFormCard>
      <div slot="header">
        <b-row>
          <b-col cols="6">
            <h4>{{$t('osm.renewal.history')}}</h4>
          </b-col>
        </b-row>
      </div>
      <div slot="formBody">
        <FITSearchableTable ref="table" vuexModule="Renewal" searchAction="getRenewalList" type="renewal" :columns="columns" :filters="filters"></FITSearchableTable>
      </div>
    </FITFormCard>
  </div>
</template>
<script type="text/javascript">
import Vue from 'vue'
import { FITSearchableTable, FITFormCard, FITAlert, FITAutoSearch } from '@/components'
import { mapGetters } from 'vuex';
export default {
  name: 'RenewalHistory',
  mounted() {},
  computed: {
    ...mapGetters(['getTranslatedArray']),
  },
  methods: {
    getTranslated(type, key) {
      console.log(type, key);
      if (!key) {
        return 'N/A';
      }
      let result = this.getTranslatedArray(this.$i18n.locale, 'Renewal', type)
        .filter((item) => {
          return item.value === key
        });
      if (result.length > 0) {
        return result[0].text;
      }
      return 'N/A';
    },
  },
  data() {
    return {
      columns: [{
          key: 'policyNumber',
          label: this.$t('osm.contents.lifePolicy.generalInformation.policyNumber'),
          sortable: true,
          formatter: (row, key, item) => {
            return this.$options.filters.isEmpty(row);
          }
        },
        {
          key: 'productEnglishName',
          label: this.$t('osm.product.productName'),
          sortable: true,
          formatter: (row, key, item) => {
            return item.productEnglishName + "</br>" + item.productChineseName;
          }
        },
        {
          key: 'chineseNameCustomer',
          label: this.$t('osm.contents.lifePolicy.generalInformation.policyOwner'),
          sortable: true,
          formatter: (row, key, item) => {
            return this.$options.filters.isEmpty(item.englishNameCustomer) + "</br>" + this.$options.filters.isEmpty(item.chineseNameCustomer)
          }
        },
        {
          key: 'policyType',
          label: this.$t('osm.renewal.list.policyType'),
          sortable: true,
          formatter: (row, key, item) => {
            return this.getTranslated('policyType', row);
          }
        },
        {
          key: 'nextPaymentDate',
          label: this.$t('osm.renewal.list.nextPaymentDate'),
          sortable: true,
          formatter: (row, key, item) => {
            return this.$options.filters.date(row)
          }
        },
        {
          key: 'modalPremium',
          label: this.$t('osm.renewal.list.modalPremium'),
          sortable: true,
          formatter: (row, key, item) => {
            if (row != null && parseFloat(row) > 0) return '$ ' + parseFloat(row).toFixed(2);
            return '$ 0'
          }
        },
        {
          key: 'updateTime',
          label: this.$t('osm.renewal.list.updateTime'),
          sortable: true,
          formatter: (row, key, item) => {
            return this.$options.filters.date(row);
          }
        }

      ],
      filters: [{
        label: this.$t('osm.renewal.list.policyType'),
        key: 'policyType',
        type: 'select',
        default: null
      }, {
        label: this.$t('osm.renewal.list.dateFromUpdateTime'),
        key: 'dateFromUpdateTime',
        type: 'datetime',
        default: ''
      }, {
        label: this.$t('osm.renewal.list.dateToUpdateTime'),
        key: 'dateToUpdateTime',
        type: 'datetime',
        default: ''
      }, {
        label: this.$t('osm.renewal.list.showRecentOnly'),
        key: 'recentRecord',
        type: 'checkbox',
        default: '0'
      }],
    }
  },
  components: {
    FITSearchableTable,
    FITFormCard,
    FITAlert,
    FITAutoSearch
  }
}

</script>



// WEBPACK FOOTER //
// src/Osm/Renewal/containers/RenewalHistory.vue